'use strict';

function centerArrows(slideshowEl) {

    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var isExcludedLayout = slideshowEl.classList.contains('images-card-circle-layout') ||
                           slideshowEl.classList.contains('images-card-portrait-split-layout');
    
    var image = slideshowEl.querySelector('.card-item.active .card-image');
    var arrows = slideshowEl.querySelectorAll('.prev-btn, .next-btn');

    if (!isMobile || isExcludedLayout) {
        arrows.forEach(function(arrow) {
            arrow.style.top = '';
            arrow.style.transform = '';
        });
        return;
    }
  
    if (image) {
        var imgHeight = image.offsetHeight;
        var offset = imgHeight / 2;
        arrows.forEach(function(arrow) {
            arrow.style.top = offset + 'px';
            arrow.style.transform = 'translateY(-50%)';
        });
    }
}

function initCardSlideshow(slideshowEl) {
    var currentIndex = 1;
    var previousIndex = 1;

    var isAutoPlay = slideshowEl.dataset.autoplay === '1' ? true : false;
    var speed = slideshowEl.dataset.speed ? slideshowEl.dataset.speed : 5;
    var autoPlayIntervalId = null;

    var items = slideshowEl.querySelectorAll('.card-item');
    var totalItems = items.length;

    if (!totalItems) return;

    items[0].classList.add('active');

    function updateHeight() {
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        if (!isMobile) {
            slideshowEl.style.height = '';
            return;
        }

        var active = slideshowEl.querySelector('.card-item.active .custom-link');
        if (active) {
            // requestAnimationFrame(function() {
                var parentStyle = getComputedStyle(active);
                var gap = parseFloat(parentStyle.rowGap) || parseFloat(parentStyle.gap) || 0;

                slideshowEl.style.height = active.offsetHeight + (gap * 2) + 'px';
            // });
        }
    }

    var activeObserver = new ResizeObserver(function() {
        updateHeight();
    });

    activeObserver.observe(items[0]);

    function showItem(nextIndex, direction) {
        var prevItem = items[previousIndex - 1];
        var nextItem = items[nextIndex - 1];

        prevItem.classList.remove('active');
        prevItem.classList.remove('slide-in-left', 'slide-in-right', 'slide-out-left', 'slide-out-right');
        nextItem.classList.remove('slide-in-left', 'slide-in-right', 'slide-out-left', 'slide-out-right');

        if (direction === 'next') {
            prevItem.classList.add('slide-out-left');
            nextItem.classList.add('slide-in-right');
        } else {
            prevItem.classList.add('slide-out-right');
            nextItem.classList.add('slide-in-left');
        }

        window.addEventListener('resize', function() {
            centerArrows(slideshowEl);
        });
        
        updateHeight();

        previousIndex = nextIndex;
    }

    slideshowEl.addEventListener('click', function(e) {
        if (e.target.classList.contains('next-btn')) {
            currentIndex = (currentIndex % totalItems) + 1;
            showItem(currentIndex, 'next');
        } else if (e.target.classList.contains('prev-btn')) {
            currentIndex = (currentIndex - 2 + totalItems) % totalItems + 1;
            showItem(currentIndex, 'prev');
        }
    });

    function nextItemAuto() {
        currentIndex = (currentIndex % totalItems) + 1;
        showItem(currentIndex, 'next');
    }

    function startAutoPlay() {
        if (isAutoPlay && !autoPlayIntervalId) {
            autoPlayIntervalId = setInterval(nextItemAuto, speed * 1000);
        }
    }

    function stopAutoPlay() {
        if (autoPlayIntervalId) {
            clearInterval(autoPlayIntervalId);
            autoPlayIntervalId = null;
        }
    }

    slideshowEl.addEventListener('click', function(e) {
        stopAutoPlay();
    });

    window.addEventListener('resize', function() {
        updateHeight();
    });

    startAutoPlay();
}

var init = function() {

    var cardLayouts = document.querySelectorAll('.images-card-layout');

    cardLayouts.forEach(function(slideshowEl) {
        initCardSlideshow(slideshowEl);
        centerArrows(slideshowEl);
    });
    
};

module.exports = {
    init: init
};
